export default __webpack_public_path__ + "static/media/suleiman.b0139c91.jpeg";